//Libs
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//App
import { EditableInput, useObserver } from "@shoothill/core";
//Modles
import { AdminDecisionEnum } from "Globals/Models/AdminDecisionEnum";
import { ApplicantUserLogEnumToString } from "Globals/Models/ApplicantUserLogEnum";
import { ApplicantUserLog } from "Globals/Models/DTO/ApplicantUserLog";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { Section } from "Globals/Models/Section";
import { theme } from "Globals/Styles/AppTheme";
import { Row } from "Globals/Styles/LayoutStyles";
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";
import AmendmentViewModel from "Globals/ViewModels/Applicant/AmendmentViewModel";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import moment from "moment";
import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { BackgroundInformationView } from "Views/Application/FormSections/BackgroundInformation/BackgroundInformationView";
import { CreditReportView } from "Views/Application/FormSections/CreditReport/CreditReportView";
import { CurrentPropertyDetailsView } from "Views/Application/FormSections/CurrentPropertyDetails/CurrentPropertyDetailsView";
import { DeclarationView } from "Views/Application/FormSections/Declaration/DeclarationView";
import { EmploymentDetailsView } from "Views/Application/FormSections/EmploymentDetails/EmploymentDetailsView";
import { IncomeDetailsView } from "Views/Application/FormSections/IncomeSavingsAndOutgoings/IncomeDetailsView";
import { NewPropertyDetailsView } from "Views/Application/FormSections/NewPropertyDetails/NewPropertyDetailsView";
import { PersonalDetailsView } from "Views/Application/FormSections/PersonalDetails/PersonalDetailsView";
import { PropertyDetailsView } from "Views/Application/FormSections/PropertyDetails/PropertyDetailsView";
import { StatementDetailsView } from "Views/Application/FormSections/StatementDetails/StatementDetailsView";
import { SupportingInformationView } from "Views/Application/FormSections/SupportingInformation/SupportingInformationView";
import { ApproveApplicationModal } from "Views/Application/Modal/ApproveApplicationModal";
import { RejectApplicationModal } from "Views/Application/Modal/RejectApplicationModal";
import { TabNavigationBar } from "./TabNavigationBar";
import { Stores, StoresContext, StoresInstance } from "Globals/Stores";
import { ApplicantStatusEnum } from "Globals/Models/ApplicantStatusEnum";
import { ApplicationFormStatusEnum } from "Globals/Models";
const domainStores = StoresInstance.Domain;

export const StyledAccordion = styled(Accordion)`
    box-shadow: none;
    background-color: transparent;
    min-height: 39px;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
    background-color: ${theme.palette.background.default};
    padding: 0;
`;
export const StyledLinkButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    background-color: ${theme.palette.hightownBlue.light};
    color: ${theme.palette.common.white};
    padding: 7px 14px;
    :first-of-type {
        margin-right: 30px;
    }
    :hover {
        background-color: ${theme.palette.hightownBlue.light};
    }
`;
export const StyledAccordionSummary = styled(AccordionSummary)`
    background-color: ${theme.palette.common.white};
    margin-bottom: 15px;
    min-height: 39px;
    p {
        color: #191919;
        font-weight: bold;
        font-size: 16px;
    }
    .MuiAccordionSummary-content.Mui-expanded {
        margin: 0px;
    }
    .Mui-expanded {
        min-height: 0px;
    }
`;
export const StyledButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 12px;
    padding: 7px 60px;
    align-items: center;
    background-color: ${theme.palette.common.black};
    color: ${theme.palette.common.white};
    &.Mui-disabled {
        color: ${theme.palette.common.white};
        opacity: 0.5;
    }
    :hover {
        background-color: ${theme.palette.common.black};
    }
    :first-of-type {
        background-color: ${theme.palette.hightownGreen.dark};
        margin-right: 30px;
        :hover {
            background-color: ${theme.palette.hightownGreen.dark};
        }
    }
`;

const personalDetails: Section = {
    title: "Personal details",
    formSection: FormSectionsEnum.PersonalDetails,
    component: PersonalDetailsView,
};
const employmentDetails: Section = {
    title: "Your employment Details",
    formSection: FormSectionsEnum.EmploymentDetails,
    component: EmploymentDetailsView,
};
const incomeSavingsAndOutgoings: Section = {
    title: "Your income, savings and outgoings",
    formSection: FormSectionsEnum.IncomeDetails,
    component: IncomeDetailsView,
};
const statements: Section = {
    title: "Statements",
    formSection: FormSectionsEnum.StatementDetails,
    component: StatementDetailsView,
};
const propertyDetails: Section = {
    title: "Where you live now and your requirements",
    formSection: FormSectionsEnum.PropertyDetails,
    component: PropertyDetailsView,
};
const currentPropertyDetails: Section = {
    title: "Current / previous home owners",
    formSection: FormSectionsEnum.CurrentPropertyDetails,
    component: CurrentPropertyDetailsView,
};
const newPropertyDetails: Section = {
    title: "New property details",
    formSection: FormSectionsEnum.NewPropertyDetails,
    component: NewPropertyDetailsView,
};
const backgroundInformation: Section = {
    title: "Your background information",
    formSection: FormSectionsEnum.BackgroundInformation,
    component: BackgroundInformationView,
};
const declaration: Section = {
    title: "Declaration",
    formSection: FormSectionsEnum.Declaration,
    component: DeclarationView,
};
const creditReport: Section = {
    title: "Credit report",
    formSection: FormSectionsEnum.CreditReport,
    component: CreditReportView,
};
const supportingInformation: Section = {
    title: "Supporting information",
    formSection: FormSectionsEnum.SupportingInformation,
    component: SupportingInformationView,
};
const sections: Section[] = [
    personalDetails,
    employmentDetails,
    incomeSavingsAndOutgoings,
    statements,
    propertyDetails,
    currentPropertyDetails,
    newPropertyDetails,
    backgroundInformation,
];

export const allSections: Section[] = [...sections, declaration, creditReport, supportingInformation];

export enum TabEnum {
    Applicant1 = 1,
    Applicant2 = 2,
    Declaration = 3,
    CreditReport = 4,
    SupportingInfo = 5,
    DeclarationTwo = 6,
    CreditReportTwo = 7,
    SupportingInfoTwo = 8,
}
export interface INavLinkOption {
    name: string;
    value: number;
}
export interface ILogEntry {
    log: ApplicantUserLog;
    viewModel?: AdminApplicantViewModel;
    firstLog?: boolean;
}
export const LogEntry = (props: ILogEntry) => {
    const { log, firstLog } = props;
    const storesContext = useContext<Stores>(StoresContext);
    let dateTime = moment.utc(log.date).local().format("HH:mm - DD/MM/YYYY");
    const [approveModalStatus, setApproveModalStatus] = useState(false);
    const [rejectModalStatus, setRejectModalStatus] = useState(false);
    //Acorrdion controlls - start
    const [expanded, setExpanded] = React.useState<FormSectionsEnum | false>(false);
    const handleChange = (panel: FormSectionsEnum) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const [logExpanded, setLogExpanded] = React.useState<string | false>("panel");
    const handleLogChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setLogExpanded(isExpanded ? panel : false);
    };
    //Acorrdion controlls - end

    const [tab, setTab] = useState<number>(TabEnum.Applicant1);

    let tabOptions: INavLinkOption[] = [
        { name: "Applicant 1", value: TabEnum.Applicant1 },
        { name: "Applicant 2", value: TabEnum.Applicant2 },
        { name: "Declaration", value: TabEnum.Declaration },
        { name: "Credit report", value: TabEnum.CreditReport },
        { name: "Supporting info", value: TabEnum.SupportingInfo },
        { name: "Declaration (App. 2)", value: TabEnum.DeclarationTwo },
        { name: "Credit report (App. 2)", value: TabEnum.CreditReportTwo },
        { name: "Supporting info (App. 2)", value: TabEnum.SupportingInfoTwo },
    ];

    function Applicant(applicant: ApplicantViewModel, viewModel: ApplicationFormViewModel, identity: string) {
        const getAmendmentViewModle = (section: FormSectionsEnum): AmendmentViewModel | undefined => {
            return applicant.amendmentsViewModel.amendmentViewModels.find((a) => a.model.formSection === section);
        };

        return (
            <>
                {sections.map((section: Section, index: number) => {
                    console.log("Rendering section: " + section.title);
                    const amendmentViewModel = getAmendmentViewModle(section.formSection);
                    return (
                        <StyledAccordion
                            expanded={expanded === section.formSection}
                            square
                            onChange={handleChange(section.formSection)}
                            key={`section-accordion-${section.title}-${index}-${identity}`}
                        >
                            <StyledAccordionSummary
                                style={{ minHeight: "39px" }}
                                expandIcon={<ExpandMoreIcon style={{ color: theme.palette.hightownBlue.light }} />}
                                aria-controls={`${section.formSection}bh-content`}
                                id={`${section.formSection}bh-header`}
                            >
                                <Typography>{section.title}</Typography>
                            </StyledAccordionSummary>
                            <StyledAccordionDetails style={{ display: "block" }}>
                                <section.component applicant={applicant} applicationFormViewModel={viewModel} />
                                <hr style={{ margin: "30px 0px", borderStyle: "dashed" }} />
                                <Row style={{ marginTop: "0px" }}>
                                    <Typography variant="body2" style={{ fontSize: "18px", fontWeight: "bold" }}>
                                        Applicant advice
                                    </Typography>
                                </Row>
                                <Row style={{ marginTop: "0px" }}>
                                    <Box width="100%">
                                        {amendmentViewModel != undefined && (
                                            <EditableInput multiLine={true} fullwidth={true} placeHolder="Notes..." viewModel={amendmentViewModel} fieldName="amendmentNotes" />
                                        )}
                                    </Box>
                                </Row>
                            </StyledAccordionDetails>
                        </StyledAccordion>
                    );
                })}
            </>
        );
    }

    function ToRenderComponent(Component: React.ComponentType<any>, section: FormSectionsEnum, applicant: ApplicantViewModel, viewModel: ApplicationFormViewModel) {
        const getAmendmentViewModle = (section: FormSectionsEnum): AmendmentViewModel | undefined => {
            return applicant.amendmentsViewModel.amendmentViewModels.find((a) => a.model.formSection === section);
        };
        const amendmentViewModel = getAmendmentViewModle(section);
        return (
            <div key={`${applicant.model.id}-${section}`}>
                <Component applicant={applicant} applicationFormViewModel={viewModel} />
                <hr style={{ margin: "30px 0px", borderStyle: "dashed" }} />
                <Row style={{ marginTop: "0px" }}>
                    <Typography variant="body2" style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Applicant advice
                    </Typography>
                </Row>
                <Row style={{ marginTop: "0px" }}>
                    <Box width="100%">
                        {amendmentViewModel != undefined && (
                            <EditableInput multiLine={true} fullwidth={true} placeHolder="Notes..." viewModel={amendmentViewModel} fieldName="amendmentNotes" />
                        )}
                    </Box>
                </Row>
            </div>
        );
    }

    const renderComponent = (applicationFormViewModel: ApplicationFormViewModel, theTab: number) => {
        let component: any = (
            <>
                <h3>Loading...</h3>
                <p style={{ fontSize: "10px" }}>if loading persists please search project code for Error code: 4f9023nui</p>
            </>
        );
        let primaryApplicant = applicationFormViewModel.applicantViewModels.find((a) => a.model.primaryApplicant);
        let secondaryApplicant = applicationFormViewModel.applicantViewModels.find((a) => !a.model.primaryApplicant);

        console.log(primaryApplicant);
        console.log(secondaryApplicant);

        switch (theTab) {
            case TabEnum.Applicant1:
                if (primaryApplicant != undefined) {
                    component = Applicant(primaryApplicant, applicationFormViewModel, "primary");
                }
                break;
            case TabEnum.Applicant2:
                if (secondaryApplicant != undefined) {
                    component = Applicant(secondaryApplicant, applicationFormViewModel, "secondary");
                }

                break;
            case TabEnum.Declaration:
                if (primaryApplicant != undefined) {
                    component = ToRenderComponent(DeclarationView, FormSectionsEnum.Declaration, primaryApplicant, applicationFormViewModel);
                }
                break;
            case TabEnum.DeclarationTwo:
                if (secondaryApplicant != undefined) {
                    component = ToRenderComponent(DeclarationView, FormSectionsEnum.Declaration, secondaryApplicant, applicationFormViewModel);
                }
                break;
            case TabEnum.CreditReport:
                if (primaryApplicant != undefined) {
                    component = ToRenderComponent(CreditReportView, FormSectionsEnum.CreditReport, primaryApplicant, applicationFormViewModel);
                }
                break;
            case TabEnum.CreditReportTwo:
                if (secondaryApplicant != undefined) {
                    component = ToRenderComponent(CreditReportView, FormSectionsEnum.CreditReport, secondaryApplicant, applicationFormViewModel);
                }
                break;
            case TabEnum.SupportingInfo:
                if (primaryApplicant != undefined) {
                    component = ToRenderComponent(SupportingInformationView, FormSectionsEnum.SupportingInformation, primaryApplicant, applicationFormViewModel);
                }
                break;
            case TabEnum.SupportingInfoTwo:
                if (secondaryApplicant != undefined) {
                    component = ToRenderComponent(SupportingInformationView, FormSectionsEnum.SupportingInformation, secondaryApplicant, applicationFormViewModel);
                }
                break;
        }

        return component;
    };

    function BasicLog() {
        return (
            <Box className="log-entry">
                <div className="logTypeWrapper">
                    <span
                        className={`${firstLog == true ? "" : "logType"}`}
                        style={firstLog ? { color: "black", fontWeight: "bold", marginRight: "50px" } : { fontWeight: "bold", marginRight: "50px" }}
                    >
                        {ApplicantUserLogEnumToString(log.type)}:
                    </span>
                </div>
                <span style={{ fontSize: "14px" }}>{dateTime}</span>
            </Box>
        );
    }

    function ApplicationLog(viewModel: AdminApplicantViewModel) {
        const [showBeginReviewButton, setShowBeginReviewButton] = useState(false);

        const [applicationFormViewModel] = useState(() => new ApplicationFormViewModel(log.applicationFormId));
        const [loading, setLoading] = useState(false);
        if (applicationFormViewModel.numberOfApplicants == 1) {
            tabOptions = tabOptions.filter(
                (t) => t.value != TabEnum.Applicant2 && t.value != TabEnum.DeclarationTwo && t.value != TabEnum.CreditReportTwo && t.value != TabEnum.SupportingInfoTwo,
            );
        }
        function save() {
            setLoading(true);
            applicationFormViewModel.applicantViewModels.forEach(async (applicant) => {
                await applicant.amendmentsViewModel.save();
            });
            domainStores.OpenSnackBar("Saved", "success");
            setLoading(false);
        }
        function cancel() {
            applicationFormViewModel.applicantViewModels.forEach((applicant) => {
                applicant.amendmentsViewModel.cancel();
            });
        }

        //Responsible with determining if the button cluster should be shown.
        function initializeFormButtonCluster() {
            setShowBeginReviewButton(applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.AwaitingReview);
        }

        function canShowButtonCluster() {
            const isSupportingInfoSubmitted: boolean = applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.SupportingInfoSubmitted;
            const isUnderReview: boolean = applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.UnderReview;
            const isAmmendmentsRequired: boolean = applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.AmendmentsRequired;

            // SW 13283
            return !showBeginReviewButton && (isSupportingInfoSubmitted || isUnderReview || isAmmendmentsRequired) && !applicationFormViewModel.model.isCompleted;
            //return !showBeginReviewButton && isSupportingInfoSubmitted && !applicationFormViewModel.model.isCompleted;
        }

        function canShowRequestSupportingInfoButton() {
            if (
                applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.ReservationPaid ||
                applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired
            ) {
                return false;
            } else {
                return applicationFormViewModel.applicationStatusEnum == ApplicationFormStatusEnum.UnderReview || ApplicationFormStatusEnum.SupportingInfoSubmitted;
            }
        }

        useEffect(() => {
            initializeFormButtonCluster();
            //clean up
            return () => {
                setShowBeginReviewButton(false);
                setLoading(false);
            };
        }),
            [applicationFormViewModel];

        return (
            <>
                <StyledAccordion expanded={logExpanded === "panel"} square onChange={handleLogChange("panel")}>
                    <AccordionSummary
                        style={{ minHeight: "39px", padding: "0px", borderBottom: "1px solid #706f6f" }}
                        expandIcon={<ExpandMoreIcon style={{ color: theme.palette.hightownBlue.light }} />}
                        aria-controls={`panel-content`}
                    >
                        <Box className="log-entry-accordian">
                            <div className="logTypeWrapper">
                                <span
                                    className={`${firstLog == true ? "" : "logType"}`}
                                    style={firstLog ? { color: "black", fontWeight: "bold", marginRight: "50px" } : { fontWeight: "bold", marginRight: "50px" }}
                                >
                                    {ApplicantUserLogEnumToString(log.type)}:
                                </span>
                            </div>
                            <span style={{ fontSize: "14px" }}>{dateTime}</span>
                        </Box>
                    </AccordionSummary>
                    <StyledAccordionDetails style={{ display: "block" }}>
                        <Row style={{ justifyContent: "flex-end" }}>
                            {canShowButtonCluster() && (
                                <>
                                    <StyledLinkButton onClick={() => setApproveModalStatus(true)} style={{ backgroundColor: "#50C14A" }}>
                                        Approve application
                                    </StyledLinkButton>
                                    <StyledLinkButton
                                        onClick={async () => {
                                            await applicationFormViewModel.applicationDecision(AdminDecisionEnum.Amends, null, null);
                                            viewModel.refresh();
                                        }}
                                        style={{ backgroundColor: "#DB9214", marginRight: "30px" }}
                                    >
                                        Send for amends
                                    </StyledLinkButton>
                                    <StyledLinkButton onClick={() => setRejectModalStatus(true)} style={{ backgroundColor: "#DC3545" }}>
                                        Reject application
                                    </StyledLinkButton>
                                </>
                            )}
                            {applicationFormViewModel.applicationStatusEnum !== ApplicationFormStatusEnum.ReservationPaid && (
                                <>
                                    {applicationFormViewModel.model.isCompleted == true &&
                                        applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired && (
                                            <>
                                                <StyledLinkButton
                                                    onClick={() => {
                                                        viewModel.updateApplicantStatus(ApplicantStatusEnum.PendingReservationFee);
                                                        applicationFormViewModel.updateApplicationFormStatus(ApplicationFormStatusEnum.PaymentRequired);
                                                    }}
                                                    style={{ backgroundColor: "#f5a30c" }}
                                                    disabled={applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired}
                                                >
                                                    Request payment
                                                </StyledLinkButton>
                                            </>
                                        )}
                                </>
                            )}
                            {canShowRequestSupportingInfoButton() && (
                                <StyledLinkButton
                                    onClick={() => {
                                        viewModel.updateApplicantStatus(ApplicantStatusEnum.AwaitingSupportingInfo);
                                        applicationFormViewModel.updateApplicationSupportingInfo();
                                    }}
                                    style={{ backgroundColor: "#50C14A", marginLeft: 30 }}
                                    disabled={
                                        applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.ReservationPaid ||
                                        applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired
                                    }
                                >
                                    Request supporting info
                                </StyledLinkButton>
                            )}
                            {applicationFormViewModel.model.isCompleted == true && applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired && (
                                <>
                                    <StyledLinkButton
                                        onClick={() => {
                                            viewModel.updateApplicantStatus(ApplicantStatusEnum.ReservationFeePaid);
                                            applicationFormViewModel.updateApplicationFormStatus(ApplicationFormStatusEnum.ReservationPaid);
                                        }}
                                        style={{ backgroundColor: "#50C14A" }}
                                        // disabled={applicationFormViewModel.applicationStatusEnum === ApplicationFormStatusEnum.PaymentRequired}
                                    >
                                        Payment received
                                    </StyledLinkButton>
                                </>
                            )}
                        </Row>
                        {/* Blur box */}
                        <Box style={{ position: "relative" }}>
                            {showBeginReviewButton && (
                                <>
                                    <StyledLinkButton
                                        onClick={() => {
                                            viewModel.updateApplicantStatus(ApplicantStatusEnum.ApplicationUnderReview);
                                            applicationFormViewModel.updateApplicationFormStatus(ApplicationFormStatusEnum.UnderReview);
                                        }}
                                        style={{ backgroundColor: "#50C14A", position: "absolute", zIndex: 3, top: "50%", left: "50%", transform: "translateX(-50%)" }}
                                    >
                                        Begin application review
                                    </StyledLinkButton>
                                </>
                            )}
                            <Box style={showBeginReviewButton ? { filter: "blur(5px)", opacity: "0.9", pointerEvents: "none" } : {}}>
                                <TabNavigationBar navLinkOptions={tabOptions} tabValue={tab} setTabValue={setTab} />
                                {/* Render tab content */}
                                {renderComponent(applicationFormViewModel, tab)}
                                {applicationFormViewModel.model.isCompleted == false && (
                                    <Box style={{ display: "flex", justifyContent: "center", margin: "15px 0px" }}>
                                        <StyledButton onClick={() => save()}>
                                            {loading ? (
                                                <>
                                                    <p style={{ marginRight: "10px" }}>Saving</p>
                                                    <CircularProgress style={{ color: "white" }} size={20} />
                                                </>
                                            ) : (
                                                <>Save</>
                                            )}
                                        </StyledButton>
                                        <StyledButton onClick={() => cancel()}>Cancel</StyledButton>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        <hr style={{ margin: "30px 0px", borderStyle: "dashed" }} />
                    </StyledAccordionDetails>
                </StyledAccordion>
                {approveModalStatus && (
                    <ApproveApplicationModal
                        isActive={approveModalStatus}
                        confirmClose={async () => {
                            await applicationFormViewModel.applicationDecision(AdminDecisionEnum.Approve, null, null);
                            setApproveModalStatus(false);
                            viewModel.refresh();
                        }}
                        onCancel={() => setApproveModalStatus(false)}
                    />
                )}
                {rejectModalStatus && (
                    <RejectApplicationModal
                        isActive={rejectModalStatus}
                        confirmClose={async (reason: string, reasonDetail: string) => {
                            await applicationFormViewModel.applicationDecision(AdminDecisionEnum.Reject, reason, reasonDetail);
                            setRejectModalStatus(false);
                            viewModel.refresh();
                        }}
                        onCancel={() => setRejectModalStatus(false)}
                        viewModel={props.viewModel}
                    />
                )}
            </>
        );
    }
    return useObserver(() => (log.applicationFormId != "" && log.applicationFormId != null && props.viewModel ? ApplicationLog(props.viewModel) : BasicLog()));
};
